<template>  
  <div class="container-fluid mt-3">
    <div class="row">

      <div class="col-12 col-xl-4">
        <div class="card border-0">
          <div class="card-header bg-transparent"><h3 class="text-muted">{{ workTitle }}</h3></div>

<transition name="slide-fade" mode="out-in">
          <component 
            :is="recipientView" 
            :prop1="recipProp1" 
            :prop2="recipProp2"
            @onRecipSComplete="successComp" 
            @onRecipUComplete="unsuccessComp"
            @onRecipSecondary="secondaryComp"
          >
          </component>
</transition>

        </div>
      </div> <!-- end build list col -->

      <div class="col-12 col-xl-4">
        <div class="card border-0">
          <div class="card-header bg-transparent"><h3 class="text-muted">Quote Build</h3></div>
            
<transition name="slide-fade" mode="out-in">
          <component 
            :is="buildView" 
            :prop1="buildProp1" 
            :prop2="buildProp2"
            @onBuildSComplete="successComp" 
            @onBuildUComplete="unsuccessComp"
            @onBuildSecondary="secondaryComp"
          >
          </component>
</transition>


          
        </div>
      </div> <!-- end build list col -->
      <div class="col-12 col-xl-4">
        <div class="card border-0">
          <div class="card-header bg-transparent"><h3 class="text-muted">&nbsp;</h3></div>



          <div class="card-body">
            <div v-if class="row">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <button class="btn btn-danger" @click="cancelQuote" >Cancel Quote</button>
                <button v-if="saveButton == false" class="btn btn-success" @click="saveQuote" :disabled="saveButton">Save Quote</button>
                <div class="d-flex justify-content-start" v-if="saveButton == true" >
                  <spring-spinner :animation-duration="2000" :size="25" color="#0E1698" class=""/>
                  <span class="ml-2" style="color: #0E1698">Saving...</span>
                </div>

              </div>
            </div>

          </div>

          </div>

          
        </div>
      </div> <!-- end build list col -->

    </div><!--  end intial row -->

  </div><!--  end container-fluid div -->
</template>


<script>
import { SpringSpinner } from 'epic-spinners'
import {store} from '../../stores/quote-builder-main-store.js'

import buildOrganization from './quoteBuilderRecipientComponents/quote-builder-organization.vue'
import buildContact from './quoteBuilderRecipientComponents/quote-builder-contact.vue'
import buildRecipient from './quoteBuilderRecipientComponents/quote-builder-recipient-summary.vue'

import buildSummary from './quoteBuilderBuildComponents/quote-builder-build-summary.vue'
import buildChooser from './quoteBuilderBuildComponents/quote-builder-build-chooser.vue'


export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      recipientView: 'builder-organization',
      recipProp1: 0,
      recipProp2: [],

      buildView: 'build-summary',
      buildProp1: 1,
      buildProp2: [this.prop3[1]],

      orgID: '',
      conID: '',
      buildID: this.prop3[1],

      workTitle: 'Quote Organization',

      quote_act_sel: '',

      saveButton: false,
    }
  },
  computed: {
    orgList () { return this.$store.state.orgList },
    contactList () { return this.$store.state.contactList },
  },
  watch: {
    
  },
  mounted() {

  },
  methods: {
    getMainView(name, x, y, z) { this.$store.dispatch("getMainView", { name: name, prop1: x, prop2: y, prop3: z })  },
    
    

    successComp(value) {
      var _this = this;
      // value[0] determines which component the info is coming from
      // value[1] is the id value of a org, contact, or build
      // value[2] is 1 one or zero that determines wether this was the intial process, or a change
      switch(value[0]) {
        case 'builder-organization':
          if(value[2] == 0) {
            _this.orgID = value[1];
            _this.workTitle = "Quote Contact"; 
            _this.recipientView = 'builder-contact';
          } else if(value[2] == 1) {
            _this.orgID = value[1];
            var setup = [_this.orgID,_this.conID];
            _this.recipProp2 = setup;
            _this.workTitle = "Recipient Summary"; 
            _this.recipientView = 'builder-recipient-summary';
          }
        break;
        case 'builder-contact':
          _this.conID = value[1];
          var setup = [_this.orgID,_this.conID];
          _this.recipProp2 = setup;
          _this.workTitle = "Recipient Summary"; 
          _this.recipientView = 'builder-recipient-summary';
          _this.recipProp1 = 1;
        break;
        case 'build-chooser':
          _this.buildID = value[1];
          var setup = [_this.buildID];
          _this.buildProp2 = setup;
          _this.buildView = 'build-summary';
        break;
        default:
      }
    },
    unsuccessComp(value) {
      var _this = this;
      switch(value[0]) {
        case 'builder-organization':
        _this.workTitle = "Recipient Summary"; 
        _this.recipientView = 'builder-recipient-summary';
        break;
        case 'builder-contact':
        _this.workTitle = "Recipient Summary"; 
        _this.recipientView = 'builder-recipient-summary';
        break;
        case 'build-chooser':
        var setup = [_this.buildID];
        _this.buildProp2 = setup;
        _this.buildView = 'build-summary';
        break;
        default:
      }
    },
    secondaryComp(value) {
      var _this = this;
      switch(value[0]) {
        case 'builder-organization':
        _this.recipientView = 'builder-organization';
        break;
        case 'builder-contact':
        _this.recipientView = 'builder-contact';
        break;
        case 'build-summary':
        _this.buildView = 'build-chooser';
        break;
        default:
      }
    },
    saveQuote(){
      var _this = this;
      _this.saveButton = true;
      var valErrors = [];

      if(_this.orgID == '' || _this.orgID == null) { valErrors.push("A organization has not been chosen for this quote. The quote cannot be completed until an organization is selected.") };
      if(_this.buildID == '' || _this.buildID == null) { valErrors.push("A build has not been chosen for this quote. The quote cannot be completed until a build is selected.") };
      if(_this.conID == '' || _this.conID == null) { valErrors.push("A contact has not been chosen for this quote. The quote cannot be completed until a contact is selected.") }; 

      if(valErrors.length > 0) { _this.errorDisplay(valErrors); _this.saveButton = false; return false; }

      _this.$toastr.warning('Saving quote. This might take a moment..', 'Please wait!', {timeOut: 0, extendedTImeout: 0})
      axios.post('/utility/user/quote/savecompletequote', {
        org_id: _this.orgID,
        build_id: _this.buildID,
        contact_id: _this.conID,
      })
        .then(function (response) {
          var msg = response.data.msg;
          var a = response.data.data;
          _this.$toastr.remove()
          _this.saveButton = false;
          _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
          _this.$emit('onSComplete', [ 'quote-builder', a ])
        })
        .catch(function (error) {
          _this.$toastr.remove()
          _this.saveButton = false;
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        })

    },
    cancelQuote() {
      var _this = this;
      _this.$swal.fire({
        title: 'Are you sure?',
        text: "Any work you have done on this quote will not be saved.",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Cancel this quote',
        cancelButtonText: 'Continue working',
        cancelButtonColor: '#3085d6',
      }).then((result) => {
        if (result.value) {
          _this.$emit('onUComplete', [ 'quote-builder' ])
        }
      })
    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },
  },    
  components:{
    SpringSpinner,
    'builder-organization' : buildOrganization,
    'builder-contact' : buildContact,
    'builder-recipient-summary' : buildRecipient,

    'build-summary' : buildSummary,
    'build-chooser' : buildChooser
  },
  filters: {

  }
}
</script>
